import {ReportAnnouncedVehicles} from "../models/Report";
import {AnnouncedVehiclesReportTemplateData} from "./AnnouncedVehiclesReportTemplateData";
import {AnnouncedVehiclesReportImportTemplate} from "./AnnouncedVehiclesImportTemplate";
import {cloneDeep} from "lodash";

export const getAnnouncedVehiclesReportTemplate = (data: ReportAnnouncedVehicles[]) => {
    return AnnouncedVehiclesReportImportTemplate(prepareData(data));
};

const prepareData = (documentData: ReportAnnouncedVehicles[]) => {
    const templateData: AnnouncedVehiclesReportTemplateData = {
        reportByDay: cloneDeep(documentData)
    };

    return templateData;
};